import { useParams } from "react-router"

import { useActiveOrganizationId } from "@/contexts"
import { isAdminEntityUnavailable } from "@/modules/admin/utils/is-admin-entity-unavailable"
import { isUnavailableBillError, useBill } from "@/services/bill/use-bill"
import { parseModelId } from "@/utils/parse-model-id"

export const useAdminBillPageState = () => {
  const { activeOrganizationId } = useActiveOrganizationId()
  const { billId: billIdParam } = useParams()

  const billId = parseModelId(billIdParam)
  const organizationId = activeOrganizationId ?? ""

  const {
    billData,
    billError,
    billIsFetched,
    billIsFetching,
    billIsLoading,
    ...billQueryResult
  } = useBill({
    billId: billId ?? null,
    organizationId,
    queryOptions: {
      enabled: Boolean(organizationId) && billId !== undefined,
    },
  })

  const billIsUnavailable = isAdminEntityUnavailable({
    data: billData,
    error: billError,
    id: billId,
    isFetched: billIsFetched,
    isUnavailableError: isUnavailableBillError,
  })

  return {
    ...billQueryResult,
    billData,
    billError,
    billId,
    billIsFetched,
    billIsFetching,
    billIsLoading,
    billIsUnavailable,
  }
}
